import type { ApiError } from './client'

/**
 * A designed refusal is expected behaviour, not an error: a user hitting a limit (the link route's and
 * Check now's 429 `task_cooldown` / `daily_limit`) sees the caller's own sentence. The global
 * `MutationCache.onError` (`report-mutation-error.ts`) reports every other thrown mutation error to
 * Sentry and the dev console, and skips a value for which `isExpectedRefusal` is true.
 */

/** A refusal thrown with its own sentence; `expected` is what the global handler reads. */
export class ExpectedRefusalError extends Error {
  readonly expected = true
}

/** True for a value that marks itself `expected: true`. Duck-typed, so it holds for any thrown value. */
export function isExpectedRefusal(error: unknown): boolean {
  return (
    typeof error === 'object' &&
    error !== null &&
    (error as { expected?: unknown }).expected === true
  )
}

/** Flags a just-thrown `ApiError` as a designed refusal (status, code and details untouched) and returns it. */
export function markExpectedRefusal(error: ApiError): ApiError {
  error.expected = true
  return error
}
